import React, { FC } from "react"
import { Container } from "@components/wrapper"
import Image from "next/image"
import { HARISENIN_PUBLIC_PAGE_ASSETS } from "@constants/const/pictures"
import clsx from "clsx"
import { Heading } from "@components/typography"

export const HomeBanner: FC = () => {
  const contactUs = () => {
    const section = (document.getElementById("#contactUs") as HTMLElement) || null
    section.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  return (
    <section className="relative" id="#overview">
      <Image
        loading="lazy"
        src={`${HARISENIN_PUBLIC_PAGE_ASSETS}/corporate_banner.png`}
        alt="banner-1"
        className={clsx("fade_in_left object-cover -z-20 sm:h-[55vw] ", "")}
        layout="fill"
      />

      <div
        className={clsx(
          "sm:bg-gradient-to-r sm:from-black z-50 sm:py-[12vw]",
          "sm-only:bg-black/60 py-15"
        )}
      >
        <Container>
          <div className="flex w-full md:w-1/2 text-center md:text-left">
            <div className="my-auto">
              <Heading headingLevel="h3" className="!text-green sm:mb-1 mb-0.5 text-lg">
                Corporate Training
              </Heading>
              <Heading
                headingLevel="banner"
                className={clsx("text-white sm:mb-5 2xl:w-2/3 sm:w-3/4", "sm-only:w-4/5 sm-only:mx-auto mb-2")}
              >
               Tingkatkan Performa Perusahaan Anda dengan Pelatihan dari Tutor Terbaik
              </Heading>
              <p
                className={clsx("text-white sm:mb-5 w-4/5", "sm-only:text-xs mb-4 sm-only:mx-auto")}
              >
                Perkuat kualitas perusahaan Anda bersama Corporate Training. Dapatkan pelatihan berbasis kurikulum terupdate dengan harga yang kompetitif.
              </p>
              <button
                onClick={contactUs}
                className={clsx(
                  "text-white bg-blue sm:px-[46px] sm:py-3 cursor-pointer z-50 ",
                  "sm-only:text-xs py-2.5 px-7.5"
                )}
              >
                Get Started
              </button>
            </div>
          </div>
        </Container>
      </div>
    </section>
  )
}
